import React, { FunctionComponent, useContext, useMemo } from "react";
import {
  ChallengeContext,
  ChallengeContextProps,
} from "/src/contexts/ChallengeContext";
import { ClubTabFilterItem, ClubRating } from "/src/domain/challenges/ChallengeProtocolData";
import { Tab, Tabs } from "@mui/material";
import { useTranslation } from "react-i18next";

import makeStyles from "@mui/styles/makeStyles";
import cs from "classnames";

export type ProtocolFiltersProps = {
  clubs: ClubTabFilterItem[];
  className?: string;
  clubsRating: ClubRating[]
};

export const ProtocolFilters: FunctionComponent<ProtocolFiltersProps> = ({
  clubs,
  className,
  clubsRating,
}) => {
  const { chosenClub, changeChosenClub } = useContext(
    ChallengeContext
  ) as ChallengeContextProps;
  const { t } = useTranslation();
  const classes = useStyles();

  if (clubs.length < 2) return null;

  const shownClubs: ClubTabFilterItem[] = useMemo(() => {
    const ratingMap = clubsRating.reduce((map, club) => {
      map[club.id] = club.place;
      return map;
    }, {} as {[key: string]: number});
    return [{
        id: "allClubs",
        name: t("allClubs"),
      }].concat(clubs.sort((a, b) => {
      const placeA = ratingMap[a.id];
      const placeB = ratingMap[b.id];
  
      // Клуб с id "0" всегда в конце
      if (a.id === "0") return 1;
      if (b.id === "0") return -1;
  
      // Клубы, которые в рейтинге, сортируются по месту в рейтинге
      if (placeA !== undefined && placeB !== undefined) {
          return placeA - placeB;
      }
  
      // Клубы, которых нет в рейтинге, идут после тех, что в рейтинге
      if (placeA !== undefined) return -1;
      if (placeB !== undefined) return 1;
  
      // Если оба клуба не в рейтинге, сортируем по имени
      return a.name.length > b.name.length ? 1 : -1;
    }));
  
  }, [clubs])

  return (
    <Tabs
      className={cs(classes.container, className)}
      textColor="secondary"
      value={chosenClub}
      indicatorColor="secondary"
      scrollButtons="auto"
      variant="scrollable"
      onChange={(_, value) => {
        changeChosenClub(value);
      }}
    >
      {shownClubs.map((club) => (
        <Tab
          value={club.id == "allClubs" ? null : club.id}
          key={club.id}
          label={club.name}
        />
      ))}
    </Tabs>
  );
};

const useStyles = makeStyles({
  container: { margin: "1rem 0" },
});
